var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueAlertTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 15V21.6667M19.9993 28.3334H20.0159M17.6915 6.48622L3.98332 30.1639C3.22298 31.4772 2.84281 32.1339 2.899 32.6728C2.94801 33.1429 3.19429 33.5701 3.57655 33.848C4.01481 34.1667 4.77358 34.1667 6.29113 34.1667H33.7074C35.2249 34.1667 35.9837 34.1667 36.422 33.848C36.8042 33.5701 37.0505 33.1429 37.0995 32.6728C37.1557 32.1339 36.7756 31.4772 36.0152 30.1639L22.3071 6.48622C21.5495 5.17761 21.1706 4.52331 20.6764 4.30356C20.2453 4.11187 19.7532 4.11187 19.3221 4.30356C18.8279 4.52331 18.4491 5.17762 17.6915 6.48622Z",
    stroke: "#147AF3",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAlertTriangle);
export default __webpack_public_path__ + "static/media/blueAlertTriangle.23b0354406beffb5ace2340f247d331a.svg";
export { ForwardRef as ReactComponent };